import type { ProgressReport } from '@brighterly/lib-core-types/progress-report/interfaces'
import type { ProgressReportStore } from './interfaces'
import type { ScopeMode } from '@shared/lib/scope'

import { beginEntry, failEntry, settleEntry } from '@shared/lib/scope'

import { createInitialState } from './state'

export const actions = {
  resetState (this: ProgressReportStore): void {
    Object.assign(this, createInitialState())
  },
  beginList (this: ProgressReportStore, id: number, mode: ScopeMode): number {
    return beginEntry(this.listById, id, mode)
  },
  settleList (this: ProgressReportStore, id: number, requestId: number, data: ProgressReport[]): void {
    settleEntry(this.listById, id, requestId, data)
  },
  failList (this: ProgressReportStore, id: number, requestId: number): void {
    failEntry(this.listById, id, requestId)
  },
  beginReport (this: ProgressReportStore, id: number, mode: ScopeMode): number {
    return beginEntry(this.reportById, id, mode)
  },
  settleReport (this: ProgressReportStore, id: number, requestId: number, data: ProgressReport | null): void {
    settleEntry(this.reportById, id, requestId, data)
  },
  failReport (this: ProgressReportStore, id: number, requestId: number): void {
    failEntry(this.reportById, id, requestId)
  },
  setNewProgressReport (this: ProgressReportStore, id: number, payload: boolean): void {
    this.newById[id] = payload
  },
}
